// extracted by mini-css-extract-plugin
export default {"list":"src-components-common-MoreListButton-more-list-button-module__listbqB52"};